export default __webpack_public_path__ + "static/media/i033vp.f2e68ed6.webp";